/*
 * (c) Copyright 2024 Calabrio, Inc.
 * All Rights Reserved. www.calabrio.com LICENSED MATERIALS
 * Property of Calabrio, Inc., Minnesota, USA
 *
 * No part of this publication may be reproduced, stored or transmitted,
 * in any form or by any means (electronic, mechanical, photocopying,
 * recording or otherwise) without prior written permission from Calabrio, Inc.
 */

import moment from 'moment';
const WyChartUtils = {
  scrollableChartSetLayoutByDay(xData, xLength, layout) {
    let defaultRange = [];
    // let xLength = this.lineChartData.xAxisData.length
    // over 1 year
    if(xLength > 364) {
      let startDate = xData[xLength - 40]
      let endDate = xData[xLength - 1]
      defaultRange = [moment(startDate).format('YYYY-MM-DD'), moment(endDate).format('YYYY-MM-DD')]
    }
    // 3 month to 1 year
    if(xLength > 90 && xLength <= 364) {
      let startDate = xData[xLength - 30]
      let endDate = xData[xLength - 1]
      defaultRange = [moment(startDate).format('YYYY-MM-DD'), moment(endDate).format('YYYY-MM-DD')]
    }
    // 7 days to  3 month
    if(xLength > 7 && xLength <= 90) {
      let startDate = xData[xLength - 6]
      let endDate = xData[xLength - 1]
      // defaultRange = [startDate, endDate]
      defaultRange = [moment(startDate).format('YYYY-MM-DD'), moment(endDate).format('YYYY-MM-DD')]
    }
    // layout.xaxis.type = "category"
    // less than 7 days
    if(xLength > 1 && xLength <= 7) {
      let startDate = xData[0]
      let endDate = xData[xLength - 1]
      defaultRange = [moment(startDate).format('YYYY-MM-DD'), moment(endDate).format('YYYY-MM-DD')]
      layout.xaxis.range = defaultRange;
      layout.xaxis.autorange = true;
    }
    if(xLength== 1) {
      let startDate = xData[0]
      let endDate = xData[xLength - 1]
      defaultRange = [moment(startDate).format('YYYY-MM-DD'), moment(endDate).format('YYYY-MM-DD')]
      layout.xaxis.range = defaultRange;
      layout.xaxis.autorange = false;
    }
    else {
      layout.xaxis.range = defaultRange;
      layout.xaxis.autorange = false
      layout.xaxis.fixedrange = false;
    }
    
  },
  
  scrollableChartSetLayoutByWeek(xLength, layout) {
    let defaultRange = [];
    // let xLength = this.lineChartData.xAxisData.length
    // over 1 year
    layout.xaxis.type = "category"
    if(xLength > 52) {
      let startDate = xLength - 13
      let endDate = xLength - 1
      defaultRange = [startDate, endDate];
      layout.xaxis.autorange = false;
    }
    // 3 month to 1 year
    if(xLength > 12 && xLength <= 52) {
      let startDate = xLength - 5
      let endDate = xLength - 1
      defaultRange = [startDate, endDate];
      layout.xaxis.autorange = false;
      // defaultRange = [moment(startDate).format('YYYY-MM-DD'), moment(endDate).format('YYYY-MM-DD')]
    }
    // 1-3 month
    if(xLength > 4 && xLength <= 12) {
      let startDate = xLength - 3;
      let endDate = xLength - 1;
      defaultRange = [startDate, endDate];
      layout.xaxis.autorange = true;
      // layout.xaxis.autorange = false;
    }
    // 7 days to  1 month
    if(xLength <= 4) {
      let startDate = 0
      let endDate = xLength - 1
      defaultRange = [startDate, endDate];
      layout.xaxis.range = defaultRange;
      layout.xaxis.autorange = true;
    }
    else {
      layout.xaxis.fixedrange = false;
      layout.xaxis.range = defaultRange;
    }
  },
  
  scrollableChartSetLayoutByMonth(xLength, layout) {
    let defaultRange = [];
    // let xLength = categary.length
    // over 1 year
    layout.xaxis.type = "category"
    if(xLength > 12) {
      let startDate = xLength - 5;
      let endDate = xLength - 1;
      defaultRange = [startDate, endDate];
      layout.xaxis.autorange = false;
    }
    // 5 - 12 month
    if(xLength > 5 && xLength <= 12) {
      let startDate = xLength - 3;
      let endDate = xLength - 1;
      defaultRange = [startDate, endDate];
      layout.xaxis.autorange = false;
    }
    // less than 5 month
    if(xLength <= 5) {
      let startDate = xLength - 2
      let endDate = xLength - 1
      defaultRange = [startDate, endDate];
      layout.xaxis.range = defaultRange;
      layout.xaxis.autorange = true;
      // layout.xaxis.autorange = false;
    }
    else {
      layout.xaxis.fixedrange = false;
      layout.xaxis.range = defaultRange;
    }
  },
  
  scrollableChartSetLayoutByYear(xLength, layout) {
    let defaultRange = [];
    // let xLength = this.lineChartData.xAxisData.length;
    // more thant 4 years
    layout.xaxis.type = "category"
    if(xLength > 4) {
      let startDate = xLength - 5
      let endDate = xLength - 1
      defaultRange = [startDate, endDate];
      layout.xaxis.autorange = false;
    }
    // less than 5 years
    if(xLength <= 4) {
      let startDate = xLength - 2
      let endDate = xLength - 1
      defaultRange = [startDate, endDate];
      layout.xaxis.range = defaultRange;
      layout.xaxis.autorange = true;
    }
    else {
      // layout.xaxis.autorange = false
      // layout.xaxis.autorange = true;
      layout.xaxis.fixedrange = false;
      layout.xaxis.range = defaultRange;
    }
  }
}

export default WyChartUtils;

